import logo from "./Images/Illustration/download (11).png";
import foot1 from "./Images/Illustration/download (2).jpg";
import foot2 from "./Images/Illustration/foot2.jpg";
import foot3 from "./Images/Illustration/foot3.jpg";
const Contact = () => {
    return (
        <section class='container-fluid'>
            <div class='row'>
                <div class='col-12 back2 text-white align'>
                    <h3>Contact</h3>
                   
                   <div className="d-flex justify-content-center pt-3"> <nav aria-label="breadcrumb ">
                        <ol class="breadcrumb ">
                            <li class="breadcrumb-item"><a href="Home">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="Contact">Contact</li>
                        </ol>
                    </nav></div>
                   
                </div>
                <div class='col-12 col-md-6 py-5'>
                    <h3>
                        Get In Touch
                    </h3>
                    <div class="row">
                        <div class="col">
                            <input type="text" class="form-control" placeholder="Yuor Name" aria-label="First name" />
                        </div>
                        <div class="col">
                            <input type="text" class="form-control" placeholder="Email Address" aria-label="Last name" />
                        </div>
                    </div>
                    <div class="row py-3">
                        <div class="col">
                            <input type="text" class="form-control" placeholder="Subject" aria-label="First name" />
                        </div>
                        <div class="col">
                            <input type="text" class="form-control" placeholder="Phone Number" aria-label="Last name" />
                        </div>

                    </div>
                    <div class="mb-3">
                        <textarea class="form-control" placeholder="Write Your Message Here..." id="exampleFormControlTextarea1" rows="3"></textarea>
                    </div>
                    <a className="btn" href="#">Send Message</a>
                </div>
                <div className="col-12 col-md-6 anch p-5">
                    <h3>
                        Contact Information
                    </h3>
                    <p> 125 Big fella St. Road, New York, Hi 5654775</p>
                    <h4 className="py-3">Email Us</h4>
                    <a href="#">info@example.com</a>
                    <h4 className="py-3">Call Us</h4>
                    <a href="#">+(09)-2134-76894-9</a>
                    <h4 className="py-3">Follow Us</h4>
                    <i class="fa-brands fa-square-facebook"></i>
                    <i class="fa-brands fa-linkedin"></i>
                    <i class="fa-brands fa-skype"></i>
                </div>
            </div>
        </section>
    )
};
export default Contact;
